import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import { getResizeImage } from '@/utils/commonUtils';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import { ImageShapeType } from '@/common/interfaces/enums/ImageShapeType';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';

import SearchPreviewCardViewModel from './SearchPreviewCard.types';

const SearchPreviewCardProps = Vue.extend({
  props: getComponentProps<SearchPreviewCardViewModel>({
    Image: {
      Url: getResizeImage('ice-cave.jpg'),
      Alt: '',
    },
    Title: 'Demo Header',
    Description: 'Demo description',
    MatchIndex: [0, 0],
    ImageShapeType: ImageShapeType.Rectangle,
  }),
});

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class SearchPreviewCard extends SearchPreviewCardProps {
  ImageSizes: ImageSizes = {
    def: new ImageSize([90, 90]),
    sizes: {},
  };

  styleSearchMatch() {
    if (this.p.MatchIndex) {
      return this.insertIntoString(
        '<span class="highlighted">',
        this.insertIntoString('</span>', this.p.Description, this.p.MatchIndex[1]),
        this.p.MatchIndex[0],
      );
    } else {
      return this.p.Description;
    }
  }

  insertIntoString(payload, string, index) {
    return string.slice(0, index) + payload + string.slice(index);
  }

  get containerAttrs(): object {
    return this.p.Link
      ? {
          href: this.p.Link,
        }
      : {};
  }
}
